/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Issue_S1Inputs */

const en_mk_tut_issue_s1 = /** @type {(inputs: Mk_Tut_Issue_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Press **Create** at the top right, or simply press the letter \`C\` wherever you are.`)
};

const id_mk_tut_issue_s1 = /** @type {(inputs: Mk_Tut_Issue_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekan tombol **Buat** di kanan atas, atau cukup tekan huruf \`C\` di mana pun Anda berada.`)
};

/**
* | output |
* | --- |
* | "Press **Create** at the top right, or simply press the letter `C` wherever you are." |
*
* @param {Mk_Tut_Issue_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_issue_s1 = /** @type {((inputs?: Mk_Tut_Issue_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Issue_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_issue_s1(inputs)
	return en_mk_tut_issue_s1(inputs)
});